import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { revokeApiKey } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { BffAdminService } from '~/gen/proto/bff/v1/admin_pb'

export function useRevokeApiKey(): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()
  return useMutation(revokeApiKey, {
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.listApiKeys,
          cardinality: 'finite',
        }),
      })
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.getApiKey,
          cardinality: 'finite',
        }),
      })
    },
  })
}
